module.exports = __webpack_public_path__ + "img/delete.f7168565.svg";